export const RESET_QUOTES_SUMMARY = "RESET_QUOTES_SUMMARY";
export const SET_QUOTES_SUMMARY_LOADING ="SET_QUOTES_SUMMARY_LOADING";
export const SHOW_PAGINATION_PROGRESS = "SHOW_PAGINATION_PROGRESS";
export const QUOTES_SUMMARY_LIST_FETCH_FAILED = "QUOTES_SUMMARY_LIST_FETCH_FAILED";
export const QUOTES_SUMMARY_LIST = "QUOTES_SUMMARY_LIST";
export const QUOTES_SUMMARY_LIST_PAGINATION = "QUOTES_SUMMARY_LIST_PAGINATION";
export const QUOTES_VIEW_DETAILS = "QUOTES_VIEW_DETAILS";
